export default "__VITE_ASSET__CpBdBWAQ__"